var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.167 17.5q-.688 0-1.177-.49a1.6 1.6 0 0 1-.49-1.177V4.167q0-.688.49-1.177t1.177-.49h5q.354 0 .594.24t.239.593a.8.8 0 0 1-.24.595.8.8 0 0 1-.593.239h-5v11.666h5q.354 0 .594.24t.239.594-.24.594a.8.8 0 0 1-.593.239zm10.146-6.667h-5.98a.8.8 0 0 1-.593-.24A.8.8 0 0 1 7.5 10q0-.354.24-.593a.8.8 0 0 1 .593-.24h5.98L12.75 7.604a.77.77 0 0 1-.23-.562q0-.334.23-.584a.8.8 0 0 1 .583-.26.79.79 0 0 1 .604.24l2.98 2.979a.8.8 0 0 1 .25.583.8.8 0 0 1-.25.583l-2.98 2.98a.78.78 0 0 1-.593.24.85.85 0 0 1-.594-.261.8.8 0 0 1-.218-.594.82.82 0 0 1 .239-.573l1.541-1.542Z"
  })));
};
export default SvgLogout;